import { useEffect, useRef, useState } from 'react';
import { SaveStatus } from './types';

interface UseConfigurationSaveStatusProps {
  saveStatus: SaveStatus;
}

export const useConfigurationSaveStatus = ({
  saveStatus,
}: UseConfigurationSaveStatusProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const hideTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Clear any existing timer
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }

    // Show badge for saving, saved, and error states
    if (
      saveStatus === 'saving' ||
      saveStatus === 'saved' ||
      saveStatus === 'error'
    ) {
      setIsVisible(true);

      // Auto-hide "saved" message after 3 seconds
      if (saveStatus === 'saved') {
        hideTimerRef.current = setTimeout(() => {
          setIsVisible(false);
        }, 3000);
      }
    } else {
      // Hide for idle state
      setIsVisible(false);
    }

    // Cleanup
    return () => {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }
    };
  }, [saveStatus]);

  return {
    isVisible,
    message:
      saveStatus === 'saving'
        ? 'Saving...'
        : saveStatus === 'saved'
          ? 'Saved'
          : saveStatus === 'error'
            ? 'Error'
            : '',
    statusClass: saveStatus,
  };
};
